import { render } from "./ModalRetouch.vue?vue&type=template&id=6a816de7&scoped=true"
import script from "./ModalRetouch.vue?vue&type=script&lang=js"
export * from "./ModalRetouch.vue?vue&type=script&lang=js"

import "./ModalRetouch.vue?vue&type=style&index=0&id=6a816de7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a816de7"]])

export default __exports__